import React from 'react';
import { FiShare2, FiCheck, FiFileText, FiHelpCircle, FiInfo } from 'react-icons/fi';
import SEO from '../components/SEO';
import '../styles/legal.css';

const LicensePage = () => (
    <div className="legal-bento-container py-5">
        <SEO
            title="License Agreement"
            description="License Agreement for the datasets provided on the electrospinning-data.org platform."
        />

        <header className="text-center mb-5 bento-header">
            <h1 className="display-4 font-weight-bold">License Agreement</h1>
            <p className="lead text-muted legal-intro-bento">
                The datasets provided on this platform are licensed under the Creative Commons Attribution 4.0 International (CC BY 4.0) License.
            </p>
            <span className="legal-date">Last Updated: December 21, 2025</span>
        </header>

        <div className="bento-grid-legal">

            <section className="legal-tile">
                <h2><FiShare2 /> What You Can Do</h2>
                <p>With this license, you are free to:</p>
                <ul className="legal-list">
                    <li><strong>Share:</strong> Copy, redistribute, and use the datasets in any medium or format for any purpose, including academic research.</li>
                    <li><strong>Adapt:</strong> Remix, transform, and build upon the datasets for any purpose, including commercial use.</li>
                </ul>
            </section>

            <section className="legal-tile">
                <h2><FiCheck /> Conditions for Use</h2>
                <p>When using the datasets, you must adhere to the following:</p>
                <ul className="legal-list">
                    <li><strong>Attribution:</strong> You must provide appropriate credit, providing a link to the license and indicating if changes were made.</li>
                    <li><strong>No Additional Restrictions:</strong> You may not apply legal or technological measures that restrict others from using the datasets as allowed by this license.</li>
                </ul>
            </section>

            <section className="legal-tile tile-accent tile-full">
                <h2><FiFileText /> Full License Text</h2>
                <p className="mb-0">
                    For detailed information about the full terms of the CC BY 4.0 License, please refer to the official documentation available{" "}
                    <a
                        href="https://creativecommons.org/licenses/by/4.0/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fw-bold"
                    >
                        here
                    </a>.
                </p>
            </section>

            <section className="legal-tile tile-full">
                <h2><FiHelpCircle /> Why This License?</h2>
                <p className="mb-0">
                    The CC BY 4.0 license allows for maximum freedom to use, modify, and share datasets while ensuring proper credit is given to original creators. This aligns with our commitment to open, collaborative research in electrospinning.
                </p>
            </section>

            <section className="legal-tile tile-accent tile-full text-center">
                <h2><FiInfo /> More Information</h2>
                <p className="mb-0">
                    Need clarification on how to attribute? Visit our <a href="/howToCite">How to Cite</a> page for specific examples.
                </p>
            </section>

        </div>
    </div>
);

export default LicensePage;
